import { render } from "./create.vue?vue&type=template&id=2da80d4e&scoped=true&ts=true"
import script from "./create.vue?vue&type=script&lang=ts"
export * from "./create.vue?vue&type=script&lang=ts"

import "./create.vue?vue&type=style&index=0&id=2da80d4e&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da80d4e"]])

export default __exports__